import React, { Component } from 'react';

import styles from './NotFound.css';
import { connect } from 'react-redux';
import { setPageReadyImmediately } from 'actions';
import Link from 'redux-first-router-link';

class NotFound extends Component {
  componentDidMount() {
    this.props.setPageReady();
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.overlay} />
        <div className={styles.content}>
          <h1 className={styles.title}>
            <span className={styles.titleBackground}>404</span>
          </h1>

          <p className={styles.description}>
            <span className={styles.descriptionBackground}>
              Такой страницы нет на сайте. Проверьте правильность адреса или {' '}
              <Link className={styles.link} to="/">
                вернитесь на главную
              </Link>
            </span>
          </p>
        </div>
      </div>
    );
  }
}

const mapDispatch = dispatch => ({
  setPageReady: () => dispatch(setPageReadyImmediately()),
});

export default connect(null, mapDispatch)(NotFound);



// WEBPACK FOOTER //
// ./src/components/screens/NotFound/NotFound.js